module.exports = __webpack_public_path__ + "img/mapbg.0c772697.png";